var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRenew = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    width: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.729 12.792q-.333-.625-.531-1.323T4 10q0-2.521 1.771-4.292Q7.542 3.938 10.125 4L8.938 2.812 10 1.75l3 3-3 3-1.062-1.062L10.125 5.5q-1.958-.042-3.292 1.292Q5.5 8.125 5.5 10q0 .458.083.875.084.417.25.813ZM10 18.25l-3-3 3-3 1.062 1.062L9.875 14.5q1.958.042 3.292-1.292Q14.5 11.875 14.5 10q0-.458-.083-.875-.084-.417-.25-.813l1.104-1.104q.333.625.531 1.323T16 10q0 2.5-1.771 4.281Q12.458 16.062 9.875 16l1.187 1.188Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRenew, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Renew.d27d66ba.svg";
export { ForwardRef as ReactComponent };